var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.54 75.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #a7a9ab;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.26,59.18c.7,0,1.26-.57,1.26-1.26v-2.52c0-.7-.56-1.26-1.26-1.26s-1.26.56-1.26,1.26v2.52c0,.69.56,1.26,1.26,1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m6.29,59.18v-5.04c0-.7-.56-1.25-1.26-1.25s-1.25.56-1.25,1.25v5.04c0,.69.56,1.26,1.25,1.26s1.26-.57,1.26-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.41,59.18v-5.04c0-.7-.56-1.25-1.26-1.25s-1.26.56-1.26,1.25v5.04c0,.69.56,1.26,1.26,1.26s1.26-.57,1.26-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11.33,61.69v-10.07c0-.7-.56-1.26-1.26-1.26s-1.26.56-1.26,1.26v10.07c0,.69.56,1.26,1.26,1.26s1.26-.57,1.26-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.37,61.69v-10.07c0-.7-.57-1.26-1.26-1.26s-1.26.56-1.26,1.26v10.07c0,.69.56,1.26,1.26,1.26s1.26-.57,1.26-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.44,64.21v-15.11c0-.7-.56-1.26-1.26-1.26s-1.25.56-1.25,1.26v15.11c0,.69.56,1.26,1.25,1.26s1.26-.57,1.26-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.47,66.73v-20.14c0-.7-.56-1.26-1.26-1.26s-1.26.56-1.26,1.26v20.14c0,.69.56,1.26,1.26,1.26s1.26-.57,1.26-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m36.51,74.28v-35.25c0-.7-.56-1.26-1.25-1.26s-1.26.56-1.26,1.26v35.25c0,.7.56,1.26,1.26,1.26s1.25-.56,1.25-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m74.28,54.14c-.7,0-1.25.56-1.25,1.26v2.52c0,.69.56,1.26,1.25,1.26s1.26-.57,1.26-1.26v-2.52c0-.7-.56-1.26-1.26-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.76,59.18v-5.04c0-.7-.56-1.25-1.26-1.25s-1.26.56-1.26,1.25v5.04c0,.69.56,1.26,1.26,1.26s1.26-.57,1.26-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.65,59.18v-5.04c0-.7-.56-1.25-1.26-1.25s-1.25.56-1.25,1.25v5.04c0,.69.56,1.26,1.25,1.26s1.26-.57,1.26-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m66.72,61.69v-10.07c0-.7-.56-1.26-1.26-1.26s-1.26.56-1.26,1.26v10.07c0,.69.57,1.26,1.26,1.26s1.26-.57,1.26-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.69,61.69v-10.07c0-.7-.56-1.26-1.25-1.26s-1.26.56-1.26,1.26v10.07c0,.69.56,1.26,1.26,1.26s1.25-.57,1.25-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m51.62,64.21v-15.11c0-.7-.56-1.26-1.26-1.26s-1.26.56-1.26,1.26v15.11c0,.69.56,1.26,1.26,1.26s1.26-.57,1.26-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.58,66.73v-20.14c0-.7-.56-1.26-1.26-1.26s-1.26.56-1.26,1.26v20.14c0,.69.57,1.26,1.26,1.26s1.26-.57,1.26-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41.55,74.28v-35.25c0-.7-.56-1.26-1.26-1.26s-1.26.56-1.26,1.26v35.25c0,.7.57,1.26,1.26,1.26s1.26-.56,1.26-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m73.02,25.18c0,2.78-2.26,5.04-5.04,5.04h-7.58c.01-.26-.06-.52-.22-.74-.2-.27-.49-.45-.82-.51-.33-.05-.67.03-.94.22l-11.49,8.37.9-7.18c.06-.46-.12-.9-.48-1.18-.36-.27-.84-.33-1.26-.16-.42.18-.71.57-.75,1.02l-.02.15h-2.51c-2.77,0-5.03-2.25-5.03-5.04V7.55c0-2.78,2.26-5.03,5.03-5.03h25.18c2.79,0,5.03,2.25,5.04,5.03v17.62ZM67.98,0h-25.18c-4.16,0-7.55,3.38-7.55,7.55v17.62c0,4.17,3.38,7.55,7.55,7.56h2.2l-.92,7.4c-.06.5.18.99.61,1.24.43.26.97.24,1.38-.06l11.79-8.57h10.13c4.17,0,7.55-3.38,7.55-7.56V7.55c0-4.17-3.38-7.55-7.55-7.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m45.32,17.62c-.69,0-1.26-.56-1.26-1.26s.57-1.26,1.26-1.26,1.26.57,1.26,1.26-.56,1.26-1.26,1.26m0-5.03c-2.08,0-3.77,1.69-3.77,3.77s1.69,3.78,3.77,3.78,3.78-1.69,3.78-3.78-1.69-3.77-3.78-3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.39,17.62c-.7,0-1.25-.56-1.25-1.26s.56-1.26,1.25-1.26,1.26.57,1.26,1.26-.56,1.26-1.26,1.26m0-5.03c-2.08,0-3.77,1.69-3.77,3.77s1.69,3.78,3.77,3.78,3.78-1.69,3.78-3.78-1.69-3.77-3.78-3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m65.47,17.62c-.69,0-1.26-.56-1.26-1.26s.57-1.26,1.26-1.26,1.26.57,1.26,1.26-.56,1.26-1.26,1.26m0-5.03c-2.08,0-3.78,1.69-3.78,3.77s1.7,3.78,3.78,3.78,3.78-1.69,3.78-3.78-1.69-3.77-3.78-3.77Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.be3bbfdf22010d7d560028013baf3511.svg";
export { ForwardRef as ReactComponent };